import React from 'react';

type SubkontraktMediaIconProps = {
  width: string;
  height: string;
};

function SubkontraktMediaIcon({ width, height }: SubkontraktMediaIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 275 265'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1032_1869)'>
        <path
          d='M2.23132 78.016L34.4413 22.873C38.5327 25.2818 59.1642 36.6996 62.4962 38.8712L30.2862 94.0172C26.7636 98.671 -2.23151 85.0783 2.23132 78.013V78.016Z'
          fill='#FBBC04'
        />
        <path
          d='M94.7756 78.0156L62.5656 22.876C58.0626 15.3821 48.3646 12.6588 40.3989 17.0848C32.4332 21.5109 30.0077 31.0452 34.5107 38.8737L66.7207 94.0201C71.2237 101.511 80.9221 104.234 88.8878 99.8079C96.5052 95.3814 99.2786 85.5091 94.7756 78.022V78.0156Z'
          fill='#4285F4'
        />
        <path
          d='M16.1687 101.938C25.0984 101.938 32.3373 94.8791 32.3373 86.1712C32.3373 77.4634 25.0984 70.4043 16.1687 70.4043C7.23896 70.4043 0 77.4634 0 86.1712C0 94.8791 7.23896 101.938 16.1687 101.938Z'
          fill='#34A853'
        />
      </g>
      <g clipPath='url(#clip1_1032_1869)'>
        <path
          d='M275 98.6811C275.009 100.573 274.617 102.445 273.849 104.173C273.08 105.902 271.953 107.447 270.542 108.707C269.131 109.967 267.468 110.913 265.664 111.482C263.86 112.051 261.955 112.229 260.077 112.006C253.239 110.994 248.228 105.044 248.395 98.1335V18.6837C248.229 11.7658 253.253 5.81213 260.1 4.81125C261.976 4.59153 263.878 4.77278 265.68 5.343C267.481 5.91322 269.141 6.85942 270.55 8.11901C271.958 9.3786 273.083 10.9229 273.85 12.6497C274.617 14.3765 275.009 16.2465 275 18.1361V98.6811Z'
          fill='#F9AB00'
        />
        <path
          d='M191.283 85.5167C198.63 85.5167 204.585 91.4727 204.585 98.8191C204.585 106.166 198.63 112.122 191.283 112.122C183.936 112.122 177.98 106.166 177.98 98.8195C177.98 91.4727 183.936 85.5167 191.283 85.5167ZM226.284 45.1985C218.903 45.6032 213.176 51.7949 213.347 59.1857V94.9176C213.347 104.615 217.614 110.502 223.866 111.757C225.804 112.15 227.805 112.106 229.725 111.629C231.644 111.153 233.433 110.255 234.962 109.001C236.492 107.747 237.722 106.168 238.566 104.38C239.409 102.591 239.844 100.637 239.838 98.6592V58.5699C239.841 56.7976 239.492 55.0425 238.809 53.4068C238.127 51.7712 237.126 50.2877 235.864 49.0431C234.603 47.7984 233.106 46.8175 231.461 46.1575C229.816 45.4974 228.057 45.1712 226.284 45.1985Z'
          fill='#E37400'
        />
      </g>
      <g clipPath='url(#clip2_1032_1869)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M64.7705 180.551C72.1682 180.041 77.8841 184.359 81.6881 189.339C85.5203 194.364 88.16 200.924 89.6112 207.376C91.0543 213.828 91.4424 220.761 90.2418 226.671C89.0897 232.346 86.0134 238.838 79.0564 240.92C72.5077 242.877 66.7675 240.031 62.6766 236.587C58.5695 233.13 55.093 228.288 52.3603 223.748C51.082 221.615 49.882 219.436 48.7626 217.215C47.6442 219.434 46.4455 221.612 45.1689 223.744C42.4362 228.288 38.9597 233.13 34.8526 236.587C30.7576 240.031 25.0214 242.877 18.4727 240.92C11.5157 238.838 8.43945 232.35 7.28736 226.671C6.09081 220.761 6.47888 213.828 7.92202 207.376C9.36921 200.924 12.0089 194.36 15.8452 189.339C19.645 184.359 25.361 180.041 32.7586 180.551C39.6954 181.036 44.7363 185.737 47.8773 189.723L48.7666 190.891L49.6519 189.719C52.7929 185.737 57.8337 181.032 64.7705 180.551ZM31.9178 192.65C30.22 192.532 27.9967 193.402 25.4823 196.7C23.0002 199.954 20.9386 204.757 19.7542 210.032C18.5738 215.307 18.4 220.457 19.1721 224.261C19.8391 227.536 20.9103 228.712 21.5652 229.124L21.8401 229.262L21.9492 229.302C22.887 229.585 24.4313 229.504 27.0427 227.305C29.65 225.114 32.3099 221.593 34.7798 217.494C35.8794 215.663 36.9021 213.787 37.8197 211.985L38.8708 209.862L39.8127 207.853L40.6454 206.002L41.3528 204.357L41.9309 202.958C41.1487 201.387 40.253 199.875 39.2508 198.434C36.6474 194.732 34.036 192.799 31.9178 192.654V192.65ZM65.6114 192.65C63.4931 192.799 60.8817 194.732 58.2784 198.434C57.2761 199.875 56.3804 201.387 55.5983 202.958L56.5159 205.153L57.284 206.907L57.7165 207.853L58.6624 209.862L59.7135 211.985C60.6311 213.787 61.6498 215.663 62.7493 217.494C65.2192 221.593 67.8832 225.114 70.4825 227.305C72.912 229.351 74.4157 229.561 75.3738 229.355L75.584 229.302C76.1095 229.141 77.5365 228.296 78.3571 224.257C79.1252 220.457 78.9594 215.307 77.775 210.028C76.5946 204.757 74.533 199.954 72.0469 196.7C69.5285 193.402 67.3092 192.536 65.6114 192.65Z'
          fill='black'
        />
      </g>
      <g clipPath='url(#clip3_1032_1869)'>
        <path
          d='M227.143 258.715C235.949 258.715 243.095 251.568 243.095 242.763V226.811H227.143C218.338 226.811 211.191 233.957 211.191 242.763C211.191 251.568 218.338 258.715 227.143 258.715Z'
          fill='#0ACF83'
        />
        <path
          d='M211.191 210.858C211.191 202.053 218.338 194.906 227.143 194.906H243.095V226.81H227.143C218.338 226.81 211.191 219.664 211.191 210.858Z'
          fill='#A259FF'
        />
        <path
          d='M211.191 178.954C211.191 170.148 218.338 163.002 227.143 163.002H243.095V194.906H227.143C218.338 194.906 211.191 187.759 211.191 178.954Z'
          fill='#F24E1E'
        />
        <path
          d='M243.098 163.002H259.05C267.855 163.002 275.002 170.148 275.002 178.954C275.002 187.759 267.855 194.906 259.05 194.906H243.098V163.002Z'
          fill='#FF7262'
        />
        <path
          d='M275.002 210.858C275.002 219.664 267.855 226.81 259.05 226.81C250.244 226.81 243.098 219.664 243.098 210.858C243.098 202.053 250.244 194.906 259.05 194.906C267.855 194.906 275.002 202.053 275.002 210.858Z'
          fill='#1ABCFE'
        />
      </g>
      <g clipPath='url(#clip4_1032_1869)'>
        <path
          d='M109.007 154.84C109.007 147.019 97.6978 143.901 90.9864 141.576C85.0677 139.515 85.1205 139.304 85.1205 138.247C85.1205 137.031 86.9701 136.556 90.2465 136.556C94.3685 136.556 97.3807 137.243 97.3807 141.048H107.474C107.474 133.121 101.82 127.678 90.2465 127.678C80.4172 127.678 75.027 131.218 75.027 137.824C75.027 145.434 81.8441 147.601 89.9295 150.401C95.1612 152.251 98.9132 153.361 98.9132 155.157C98.9132 156.373 97.8563 157.113 92.7831 157.113C85.4904 157.113 83.4294 155.422 83.4294 150.93H73.3359C73.3359 160.601 78.8319 165.991 92.4132 165.991C104.039 165.991 109.007 161.605 109.007 154.84ZM111.486 151.617C111.486 160.918 117.722 165.991 129.083 165.991C140.498 165.991 146.787 160.918 146.787 151.617V128.206H136.693V146.649C136.693 152.938 136.852 157.113 129.083 157.113C121.315 157.113 121.579 152.938 121.579 146.649V128.206H111.486V151.617ZM150.887 165.462H165.208C175.196 165.462 183.81 164.405 183.81 155.58C183.81 147.125 177.204 147.336 171.55 147.072V144.641C175.566 144.271 181.062 144.958 181.062 137.348C181.062 130.003 176.147 128.206 165.261 128.206H150.887V165.462ZM160.98 141.629V137.084H166.688C169.066 137.084 170.968 136.926 170.968 139.357C170.968 141.999 169.066 141.629 166.688 141.629H160.98ZM160.98 156.584V150.507H166.635C171.127 150.507 173.716 149.926 173.716 153.572C173.716 157.007 171.127 156.584 166.635 156.584H160.98Z'
          fill='#1F2937'
        />
        <path
          d='M195.057 152.991C199.02 152.991 201.662 150.137 201.662 146.755C201.662 143.479 199.02 140.678 195.057 140.678C190.987 140.678 188.609 143.479 188.609 146.755C188.609 150.137 190.987 152.991 195.057 152.991Z'
          fill='#F85F3B'
        />
      </g>
      <defs>
        <clipPath id='clip0_1032_1869'>
          <rect
            width='97.018'
            height='87.1646'
            fill='white'
            transform='translate(0 14.9531)'
          />
        </clipPath>
        <clipPath id='clip1_1032_1869'>
          <rect
            width='97.018'
            height='107.629'
            fill='white'
            transform='translate(177.98 4.7207)'
          />
        </clipPath>
        <clipPath id='clip2_1032_1869'>
          <rect
            width='97.018'
            height='97.018'
            fill='white'
            transform='translate(0 162.35)'
          />
        </clipPath>
        <clipPath id='clip3_1032_1869'>
          <rect
            width='63.808'
            height='95.712'
            fill='white'
            transform='translate(211.191 163.002)'
          />
        </clipPath>
        <clipPath id='clip4_1032_1869'>
          <rect
            width='133.135'
            height='38.3131'
            fill='white'
            transform='translate(70.9336 127.678)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SubkontraktMediaIcon;
